// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"67":"daca0ff0","212":"715347a8"}[chunkId] + ".chunk.css";
};